import { ObjectListRequestType } from '../ObjectListResponseTypes'

export interface TicketRequest {
  description: string
  date: string
  departmentId: number
  departmentSubId: number
  ticketOpenTypeId: number
  statusId: number
  ticketId: number
  content: string
  partnerId: number
  attachments: Array<TicketAttachmentRequest>
  ticketLinks: Array<TicketLinkRequest>
  priority: string
  emailAddress: string
}

export interface TicketFormData {
  department: string
  category: string
  subject: string
  departmentId: number | undefined
  departmentSubId: number | undefined
  content: string
  files: Array<File>
  priority: string
}
export interface TicketLinkRequest {
  objectName: string
  objectId: number
}
export interface TicketHistoryRequest {
  ticketId: number
  date: string
  inputTypeId: number
  actionTypeId: number
  content: string
  attachments: Array<File>
}
export const isTicketHistoryRequest = (request: any): request is TicketHistoryRequest => {
  if (request === undefined) {
    return false
  }
  return 'ticketId' in request && 'content' in request
}
export interface TicketHistoryRequestBody {
  date: string
  inputTypeId: number
  actionTypeId: number
  content: string
  employeeId: number
  attachments: Array<TicketAttachmentRequest>
}
export interface TicketAttachmentRequest {
  fileName: string
  data: string
}

export interface TicketListRequestBody extends ObjectListRequestType {
  statusId?: number
  subject?: string
  content?: string
  ticketId?: number
  priority?: string
}

export interface ticketFilter {
  subject?: string
  content?: string
  ticketId?: number
  priority?: string
}

export interface TableFilterRequest {
  fieldName: string
  operator: string
  fieldValue: string
}

export interface TicketHistoryListRequestBody extends ObjectListRequestType {}
